import React from "react";
import TextField from "@material-ui/core/TextField";

export const TextInput = props => (
  <TextField
    margin="normal"
    style={{ width: "100%" }}
    variant="outlined"
    {...props}
    onChange={event => props.onChange(event.target.value)}
  />
);
